module.exports = __webpack_public_path__ + "images/emoji/running_shirt_with_sash.9bac5fc3b901ec1bd372.png";